import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { fetchWorkoutPlanTags } from 'src/models/platform/platform';

interface WorkoutPlanTagFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

export const WorkoutPlanTagFilter: React.FC<WorkoutPlanTagFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const { data: workoutPlanTags = [] } = useQuery({
    queryKey: ['workoutPlanTags'],
    queryFn: () => fetchWorkoutPlanTags(),
    staleTime: 60000,
    gcTime: 60000,
    select: (data) => data.map((t) => t.name),
  });

  const selectedTag = workoutPlanTags.find((t) => t === value);

  if (valueOnly) {
    return <>{selectedTag || ''}</>;
  }

  return (
    <Autocomplete
      options={workoutPlanTags}
      getOptionLabel={(option: string) => option}
      value={selectedTag || null}
      onChange={(_, newValue) => {
        setValue(newValue?.id || '');
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Plan Tag" />
      )}
    />
  );
};
